module.exports = __webpack_public_path__ + "static/media/MrsMeyers.44539d14.png";